module.exports = __webpack_public_path__ + "img/google-pay.207e15f.svg";